// Substituted at bundle-deploy time by `redoReferralsApp()` — keep the
// string-literal `globalThis.X` reads or substitution stops working.

declare global {
  var DATADOG_APPLICATION_ID: string | undefined;
  var DATADOG_CLIENT_TOKEN: string | undefined;
  var REDO_REFERRALS_APP_VERSION: string | undefined;
  var REDO_REFERRALS_SERVER_URL: string | undefined;
}

export const DATADOG_APPLICATION_ID = globalThis.DATADOG_APPLICATION_ID || "";

export const DATADOG_CLIENT_TOKEN = globalThis.DATADOG_CLIENT_TOKEN || "";

export const REDO_REFERRALS_APP_VERSION =
  globalThis.REDO_REFERRALS_APP_VERSION || "_";

export const REDO_REFERRALS_SERVER_URL =
  globalThis.REDO_REFERRALS_SERVER_URL || "http://localhost:8045";
